<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Add Referral Code</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>
      /
      <b>{{ lps() }}</b>
      /
      <router-link to="/lps/affiliate">Affiliates</router-link>
      /
      <router-link :to="{
        name: 'affiliate-details',
        params: { id: 1 }
      }">
        Affiliate Details
      </router-link>
      /
      <b>Add Referral Code</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    <div style="margin-bottom: 30px;"></div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Active -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">Enter Referral Code's Details</h4>
            <br />
            <div class="row">
              <div class="col-12">
                <label>Referral Code Name</label>
                <input type="text" class="form-control" style="margin-bottom: 10px;" v-model="referralCodeName" />
                <label>Referral Code</label>
                <div class="row">
                  <div class="col-6">
                    <input type="text" class="form-control" style="margin-bottom: 10px;" v-model="referralCode" />
                  </div>
                  <div class="col-6">
                    <button class="btn btn-primary btn-rounded" @click="generateReferralCode()">
                      Generate New Referral Code
                    </button>
                  </div>
                </div>
                <label>Referral Code Type</label>
                <div class="row">
                  <label class="radio ml-3">
                    <input type="radio" name="codeType" v-model="referralCodeType" v-bind:value="c">
                    <span>Media</span>
                    <span class="checkmark"></span>
                  </label>
                  <label class="radio ml-3">
                    <input type="radio" name="codeType" v-model="referralCodeType" v-bind:value="d">
                    <span>Promoters</span>
                    <span class="checkmark"></span>
                  </label>
                </div>

                <label>Start Date</label>
                <input type="date" class="form-control" style="margin-bottom: 10px;" v-model="startDate" />
                <label>End Date</label>
                <input type="date" class="form-control" style="margin-bottom: 10px;" v-model="expiryDate" />
                <label>User Points Earned (optional)</label>
                <input type="number" step="0.01" min="0.1" v-model="userPointsEarned" class="form-control"
                  style="margin-bottom: 10px;" placeholder="Enter points value" />
                <label>Activation Status</label>
                <div class="row">
                  <label class="radio radio-success ml-3">
                    <input type="radio" name="activeStatus" v-model="active" v-bind:value="a">
                    <span>Active</span>
                    <span class="checkmark"></span>
                  </label>
                  <label class="radio radio-danger ml-3">
                    <input type="radio" name="activeStatus" v-model="active" v-bind:value="b">
                    <span>Inactive</span>
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>

            <div class="row" style="margin-top: 30px;">
              <div class="col-12 text-center">
                <span class="col-4"></span>

                <button class="btn btn-primary btn-rounded col-2" @click="onSubmit()">
                  Submit
                </button>
                <span class="col-4"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import dateManipulation from "@/mixins/dateManipulation";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: "account-add",
  mixins: [dateManipulation],
  components: { vSelect },

  data() {
    return {
      referralCodeName: "",
      affiliate: '',
      referralCode: "",
      referralCodeType: 1,
      userPointsEarned: "",
      startDate: "",
      expiryDate: "",
      active: 1,
      a: 1,
      b: 0,
      c: 1,
      d: 2
    };
  },

  computed: {

  },

  methods: {
    getReferralCodeDetails() {
      return {
        name: this.referralCodeName,
        referral_code: this.referralCode,
        affiliate_id: this.affiliate,
        start_date: this.startDate,
        expiry_date: this.expiryDate,
        user_points: this.userPointsEarned,
        type: this.referralCodeType,
        active: this.active
      }
    },
    onSubmit() {
      let token = this.checkToken();

      swal({
        icon: "warning",
        text: "Are you sure?",
        buttons: ["Cancel", "Yes"]
      }).then(confirm => {
        if (!confirm) {
          return;
        }


        axios
          .post(
            axios.lpsURL + '/referral_code/store', this.getReferralCodeDetails(),
            {
              headers: {
                Authorization: "Bearer " + token
              }
            }
          )
          .then(res => {
            if (res.data.success) {
              swal({
                icon: "success",
                text: res.data.message
              }).then(() => {

                this.$router.go(-1);

              });
            } else {
              swal({ icon: "error", text: res.data.message });
            }
          });
      });
    },

    // Check Token
    checkToken() {
      let token = localStorage.getItem("token");
      if (token != null) {
        token = JSON.parse(token);
        token = token.access_token;
        return token;
      }
      return false;
    },

    generateReferralCode() {
      let alphaNum = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
      let a = alphaNum.split(""),
        n = a.length;

      for (let i = n - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        let tmp = a[i];
        a[i] = a[j];
        a[j] = tmp;
      }

      let randomizedString = a.join("");

      // console.log(randomizedString.substring(0, 7));
      this.referralCode = randomizedString.substring(0, 7);
    },

    lps() {
      return this.$lps();
    }
  },

  async created() {

  },

  mounted() {
    this.generateReferralCode();
    this.affiliate = this.$route.params.id;
    // alert(this.$route.params.id)
  }
};
</script>
